import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

export interface Popular {
  id: string
  type: string
  attributes: {
    course: ICourseCard
    enrol: IEnrolCard
  }
}

const getPopularsLibrary = ({ page = 1, perPage = 8, search = '' }) => {
  return api
    .get<{ data: Popular[]; total: number }>('/courses/popular_library', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) => ({
      courses: data.data.map((popular) => popular.attributes),
      total: data.total,
    }))
}

export default getPopularsLibrary
